<script setup>
import { onMounted, ref } from 'vue';

defineProps({
    modelValue: String,
    placeholder:String,
    textColor: {
        type:Boolean,  // Accept Boolean or Object
        default: false,  // Correct spelling for 'default'
  }
});

defineEmits(['update:modelValue']);

const input = ref(null);

onMounted(() => {
    if (input.value.hasAttribute('autofocus')) {
        input.value.focus();
    }
});

defineExpose({ focus: () => input.value.focus() });
</script>
<style>
.form-control:disabled, .form-control[readonly]{
    background-color: white;
}
</style>
<template>
    <input type="text"
        ref="input"
        class="form-control border-gray-300  rounded-md"
        :class="[textColor ? `text-[#4169E1] font-bold` : '']"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
        :placeholder ="placeholder"
    />
</template>